<template>
  <el-select
    v-model="departmentId"
    style="vertical-align: top;"
    placeholder="请选择部门"
    clearable
    @change="handleChange">
    <el-option
      v-for="item in list"
      :key="item.departmentId"
      :label="item.departmentName"
      :value="item.departmentId">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'DeptSelect',
  props: {
    value: {
      required: true
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    departmentId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    fetchList() {
      this.$store.dispatch('vendor/getdepartments', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          isSaleBranch: 1
        },
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
